'use client';

import { SessionProvider } from 'next-auth/react';
import { useEffect } from 'react';
import { getSession } from 'next-auth/react';
import { useSessionStore } from '@/stores/useSessionStore';
import { usePathname } from 'next/navigation';
import { CurrentUserProvider } from '@/providers/CurrentUserProvider';

function SyncSessionToZustand() {
  const setSession = useSessionStore((s) => s.setSession);
  const pathname = usePathname();

  useEffect(() => {
    const sync = async () => {
      const session = await getSession(); // ❗ fetch from server
      setSession(session ?? null);
    };

    sync(); // Call on initial load + pathname change
  }, [pathname, setSession]);

  return null;
}

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider refetchInterval={0} refetchOnWindowFocus={true}>
      <SyncSessionToZustand />
      <CurrentUserProvider>
        {children}
      </CurrentUserProvider>
    </SessionProvider>
  );
}
